import Component from '../Component';
import Inspector from '../inspector/Inspector';

const WP_SelectControl = wp.components.SelectControl;

export default class SelectControl extends Component {
  render() {
    if (this.isView()) return null;

    if (!this.props.options) {
      return 'Loading ...';
    }

    return (
      <Inspector>
        <Inspector.Body title={this.props.title || this.props.label || 'Select'}>
          <Inspector.Row>
            <WP_SelectControl
              label={this.props.label || 'Choose'}
              value={this.attr()}
              onChange={val => this.setAttr(val)}
              options={this.props.options}
            />
          </Inspector.Row>
        </Inspector.Body>
      </Inspector>
    );
  }
}
